<!-- version 2021/05/20 -->
<template>
    <a class="btn" :href="link">{{ title }}</a>
</template>

<script>
    export default {
        props: {
            link: String,
            title: String
        }
    }
</script>

<style lang="sass" scoped>
    a
        z-index: 2
        border-radius: 6px !important
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
        background-color: #FFF !important
        color: #28c3cd !important
</style>